import { Ajuste, hasPermissionAjustes } from '@/service/api'
import { FormField } from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { useOutletContext, useParams } from 'react-router-dom'
import { z } from 'zod'
import { ReprovarService as useService } from '../../service/reprovar'

const ReprovarAjusteModal: React.FC = () => {
    const { handleSubmit, isLoading } = useService()
    const { tipo, id } = useParams()
    const { data } = useOutletContext<{ data: Ajuste[] }>()
    const ajuste = data.find(it => it.id === `${tipo}_${id}`)

    return (
        <Dialog.Root
            open={hasPermissionAjustes()}
            width="lg"
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={z.object({
                motivo: z
                    .string()
                    .trim()
                    .min(1, 'Justificativa é obrigatório')
                    .max(150),
            })}
        >
            {ajuste ? (
                <Dialog.Title action="Reprovar ajuste">
                    {ajuste.tipoAjuste} · {ajuste.data}
                </Dialog.Title>
            ) : (
                <Dialog.Title>Reprovar ajuste</Dialog.Title>
            )}
            <Dialog.Content>
                <FormField
                    name="motivo"
                    label="Justificativa"
                    multiline
                    required
                    max={150}
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton color="error" />
            </Dialog.Actions>
        </Dialog.Root>
    )
}

export default ReprovarAjusteModal
